import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a148299"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reward-wrapper" }
const _hoisted_2 = { class: "img-wrapper" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "date fw6" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "point-wrapper" }
const _hoisted_7 = { class: "point" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "img",
        src: $props.item.ImageURL,
        alt: $props.item.Name
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("h6", _hoisted_4, _toDisplayString($props.item.EffectiveFrom) + " - " + _toDisplayString($props.item.EffectiveTo), 1),
    _createElementVNode("h4", {
      class: "name fw6",
      textContent: _toDisplayString($props.item.Name)
    }, null, 8, _hoisted_5),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_SvgIcon, {
        class: "token",
        "icon-name": "token"
      }),
      _createElementVNode("h5", _hoisted_7, _toDisplayString($setup.getVICPrefixByMemberClub($props.item.MemberClub)) + "VIC " + _toDisplayString(_ctx.$t('points')) + ": " + _toDisplayString($props.item.PointsToRedeem.toLocaleString()), 1)
    ])
  ]))
}